import React from 'react';
import { Box, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import dropdownIcon from '../../../../../assets/Admin/Accordion/dropdown-icon.svg';
import './Academic.css';
import { motion, AnimatePresence } from 'framer-motion';

const Academic = ({
  data,
  expanded,
  handleAccordionClick,
  handleEdit,
  tooltipContent,
  conversionRate = 7.5,
  canManageFeeSettings = () => true,
}) => {
  return (
    <Box className="academic-container" style={{ maxWidth: '100%', overflowX: 'hidden' }}>
      {data.map((category, categoryIndex) => (
        <Box
          key={categoryIndex}
          className={`accordion ${expanded === category.name ? 'accordion-expanded' : ''}`}
        >
          <Box
            className="accordion-header-academic"
            onClick={() => handleAccordionClick(category.name)}
          >
            <span className="accordion-title">{category.name}</span>
            <img
              src={dropdownIcon || '/placeholder.svg'}
              alt="Dropdown Icon"
              className={`chevron-icon ${expanded === category.name ? 'rotate' : ''}`}
            />
          </Box>

          <AnimatePresence initial={false}>
            {expanded === category.name && (
              <motion.div
                key="academic-content"
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: 'auto', opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.25, ease: 'easeInOut' }}
                style={{ overflow: 'hidden' }}
              >
                <Box className="academic-table-wrapper">
                  <table className="academic-fee-table">
                    <thead>
                      <tr className="academic-table-header-row">
                        <th className="academic-table-header academic-session-type-header">
                          Type of Session
                        </th>
                        <th className="academic-table-header academic-klass-header" colSpan="3">
                          <div className="academic-header-content">
                            Klass Commission
                            <Tooltip title={tooltipContent.klassCommission}>
                              <InfoIcon className="academic-info-icon" />
                            </Tooltip>
                          </div>
                        </th>
                        <th className="academic-table-header academic-service-header" colSpan="3">
                          <div className="academic-header-content">
                            Service Fee
                            <Tooltip title={tooltipContent.platformFees}>
                              <InfoIcon className="academic-info-icon" />
                            </Tooltip>
                          </div>
                        </th>
                        <th
                          className="academic-table-header academic-instructor-header"
                          colSpan="3"
                        >
                          <div className="academic-header-content">
                            Instructor
                            <Tooltip title={tooltipContent.teacher}>
                              <InfoIcon className="academic-info-icon" />
                            </Tooltip>
                          </div>
                        </th>
                        <th className="academic-table-header academic-total-header" colSpan="2">
                          <div className="academic-header-content">
                            Total
                            <Tooltip title={tooltipContent.total}>
                              <InfoIcon className="academic-info-icon" />
                            </Tooltip>
                          </div>
                        </th>
                        <th className="academic-table-header academic-actions-header">Actions</th>
                      </tr>
                      <tr className="academic-table-subheader-row">
                        <th className="academic-subheader academic-session-type-subheader"></th>
                        <th className="academic-subheader">Koins</th>
                        <th className="academic-subheader">%age</th>
                        <th className="academic-subheader">Riyals</th>
                        <th className="academic-subheader">Koins</th>
                        <th className="academic-subheader">%</th>
                        <th className="academic-subheader">Riyals</th>
                        <th className="academic-subheader">Koins</th>
                        <th className="academic-subheader">%age</th>
                        <th className="academic-subheader">Riyals</th>
                        <th className="academic-subheader">Koins</th>
                        <th className="academic-subheader">Riyals</th>
                        <th className="academic-subheader academic-actions-subheader"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {category.sessions.map((session, sessionIndex) => (
                        <tr
                          key={sessionIndex}
                          className={`academic-table-row ${sessionIndex % 2 === 1 ? 'academic-alternate-row' : ''}`}
                        >
                          <td className="academic-table-cell academic-session-type-cell">
                            {session.type}
                          </td>
                          <td className="academic-table-cell academic-klass-koins-cell">
                            {session.klassCom.koins}
                          </td>
                          <td className="academic-table-cell academic-klass-percentage-cell">
                            {session.klassCom.percentage}
                          </td>
                          <td className="academic-table-cell academic-klass-riyals-cell">
                            {(parseFloat(session.klassCom.koins) * conversionRate).toFixed(2)}
                          </td>
                          <td className="academic-table-cell academic-service-koins-cell">
                            {session.cutout.koins}
                          </td>
                          <td className="academic-table-cell academic-service-percentage-cell">
                            {session.cutout.percentage}
                          </td>
                          <td className="academic-table-cell academic-service-riyals-cell">
                            {(parseFloat(session.cutout.koins) * conversionRate).toFixed(2)}
                          </td>
                          <td className="academic-table-cell academic-instructor-koins-cell">
                            {session.teacher.koins}
                          </td>
                          <td className="academic-table-cell academic-instructor-percentage-cell">
                            {session.teacher.percentage}
                          </td>
                          <td className="academic-table-cell academic-instructor-riyals-cell">
                            {(parseFloat(session.teacher.koins) * conversionRate).toFixed(2)}
                          </td>
                          <td className="academic-table-cell academic-total-koins-cell">
                            {session.total.koins}
                          </td>
                          <td className="academic-table-cell academic-total-riyals-cell">
                            {(parseFloat(session.total.koins) * conversionRate).toFixed(2)}
                          </td>
                          <td className="academic-table-cell academic-actions-cell">
                            <button
                              className="academic-edit-button"
                              onClick={() => handleEdit(categoryIndex, sessionIndex)}
                            >
                              Edit
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Box>
              </motion.div>
            )}
          </AnimatePresence>
        </Box>
      ))}
    </Box>
  );
};

export default Academic;
